import { Flex, Typography } from "@qws-org/ui-kit";
import type { FC } from "react";

type MainSliderCounterProps = { currentIndex: number; total: number };

export const Counter: FC<MainSliderCounterProps> = ({
  currentIndex,
  total,
}) => {
  return (
    <Flex as="span" align="center" gap={8}>
      <Typography
        fontWeight="desktop.bold"
        color="text-primary-default"
        fontSize="title.desktop.medium"
        lineHeight="title.desktop.medium"
      >
        {currentIndex + 1 < 9 ? `0${currentIndex + 1}` : currentIndex + 1}
      </Typography>
      <Typography
        fontWeight="desktop.bold"
        color="text-secondary-default"
        fontSize="title.desktop.small"
        lineHeight="title.desktop.small"
      >
        {total < 9 ? `/0${total}` : `/${total}`}
      </Typography>
    </Flex>
  );
};
